import React, { useEffect, useState } from 'react'
import styles from './style.module.scss'
import CustomLink from '@shared/components/customLink'
import car from '@assets/images/f1/icons/car.png'
import speed from '@assets/images/f1/icons/speed.png'
import flag from '@assets/images/f1/icons/flag.png'
import helmet from '@assets/images/f1/icons/helmet.png'
import Image from 'next/future/image'
import EventSchedule from '../widgets/EventSchedule'
import PropTypes from 'prop-types'

const f1Data = [
  { icon: helmet, title: 'Drivers', value: '21', link: '/formula1-racing/drivers' },
  { icon: flag, title: 'Races', value: '24', link: '/formula1-racing/circuits' },
  { icon: speed, title: 'Mph+', value: '233', link: '/formula1-racing/teams' },
  { icon: car, title: 'Teams', value: '10', link: '/formula1-racing/teams' }
]
const navItems = [
  { title: "Season'25", slug: 'circuits' },
  { title: 'Drivers', slug: 'drivers' },
  { title: 'Teams', slug: 'teams' }
]

function F1Header({ raceData }) {
  const [scrollY, setScrollY] = useState(0)

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const headingStyle = {
    transform: `translateY(${Math.min(scrollY, 200)}px)`,
    opacity: `${1 - Math.min(scrollY / 200, 1)}`,
    transition: 'transform 0.3s ease-out, opacity 0.3s ease-out'
  }
  return (
    <>
      <div className={styles.headerLayout}>
        <div className='container' style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start'
        }}>
          <header className={styles.header}>
            <nav className={styles.nav}>
              {/* {['Circuits', 'Drivers', 'Teams'].map((item) => (
              <CustomLink key={item} href={
                 `/formula1-racing/${item.toLowerCase()}`
              } >
                <a>
                  <span className={styles.link}>{item}</span>
                </a>
              </CustomLink>
            ))} */}
              {navItems.map(({ title, slug }) => (
                <CustomLink key={slug} href={`/formula1-racing/${slug}`}>
                  <a>
                    <span className={styles.link}>{title}</span>
                  </a>
                </CustomLink>
              ))}
            </nav>
          </header>
          <h1
            className={styles.heading}
            style={headingStyle}
          >
            F1 TURF IS HERE
          </h1>
          <div className={styles.headerData}>
            <div className={styles.grid}>
              {f1Data.map((f1, i) => {
                return (
                  <CustomLink href={f1?.link} key={i}>
                    <a>
                      <div key={i} className={styles.f1Box}>
                        <Image src={f1?.icon} alt={f1?.title} width={64} height={64} layout='raw' />
                        <div className='d-flex flex-column gap-2'>
                          <span className={styles.title}>{f1?.value}</span>
                          <spa className={styles.value}>{f1?.title}</spa>
                        </div>
                      </div>
                    </a>
                  </CustomLink>
                )
              })}
            </div>
            <div>
              <Image src='https://media.oneturf.news/media/attachments/1745586365548_car.webp' alt='Formula 1 car' width={528} height={523} layout='raw' className='d-none d-md-flex' />
            </div>
            <EventSchedule raceData={raceData} />
          </div>
          <Image src='https://media.oneturf.news/media/attachments/1745586365548_car.webp' alt='Formula 1 car' width={331} height={266} layout='raw' className='d-flex d-md-none' />
        </div>
      </div>
    </>
  )
}

F1Header.propTypes = {
  raceData: PropTypes.array
}

export default F1Header
